module.exports = __webpack_public_path__ + "assets/img/gz.59830685.jpg";